<template>
  <v-card
    style="border-radius: 7px"
    class="px-2 py-2"
  >
    <v-card-title class="zerostock__close pa-0">
      <v-btn
        text
        icon
        plain
        depressed
        class="ma-0"
        @click="close"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-container
      v-if="!requestSent"
      class="pa-0"
    >
      <v-card-text class="zerostock__title">
        SOLICITAR ESTOQUE NEGATIVO
      </v-card-text>

      <v-card-text
        class="zerostock__subtitle"
        v-html="getSubtitle"
      />

      <div class="zerostock__input">
        <v-text-field
          v-model="quantity"
          class="zerostock__custom-label"
          color="primary"
          placeholder="Ex.: 3"
          :label="hasStock ? 'Digite quantas unidades extras deseja' : 'Digite a quantidade desejada'"
          type="number"
          :disabled="hasStock"
        />
      </div>

      <div class="zerostock__btn-wrapper">
        <v-btn
          medium
          depressed
          color="#140C22"
          class="zerostock__confirm"
          :disabled="quantity < 1"
          @click="createRequest()"
        >
          Solicitar para a gerência
        </v-btn>

        <v-btn
          flat
          color="error"
          class="zerostock__decline"
          @click="close()"
        >
          Cancelar
        </v-btn>
      </div>
    </v-container>

    <v-container v-else>
      <div class="zerostock__animation__container">
        <div class="zerostock__animation__circle-border" />
        <div class="zerostock__animation__circle">
          <div class="zerostock__animation__success" />
        </div>
      </div>

      <v-card-text class="zerostock__msg">
        Solicitação enviada e produto
        adicionado ao carrinho com sucesso!
      </v-card-text>

      <div class="zerostock__btn-wrapper">
        <v-btn
          dark
          color="#140C22"
          style="width: 75px"
          class="zerostock__confirm"
          @click="addProductToCart()"
        >
          Voltar
        </v-btn>
      </div>
    </v-container>
  </v-card>
</template>

<script>
import { everything } from '@sejazipper/layer-api-client';
import { mapGetters } from 'vuex';
import { useZipperApi } from '../../composables/useZipperApi';

const { client } = useZipperApi();

export default {
  props: {
    addToCart: {
      type: Function,
      default: () => {},
    },
    close: {
      type: Function,
      default: () => {},
    },
    productSelected: {
      type: Object,
      default: () => ({}),
    },
    hasStock: {
      type: Boolean,
      default: false,
    },
    storeStockQuantity: {
      type: Number,
      default: 0,
    },
    desiredAmount: {
      type: Number,
      default: 0,
    },
  },

  data: () => ({
    requestSent: false,
    requestInfo: null,
    quantity: null,
  }),

  computed: {
    ...mapGetters([
      'getCustomer',
      'getProfile',
      'getStore',
    ]),

    getSubtitle() {
      let string = '';

      if (this.hasStock) {
        string += 'A quantidade solicitada ultrapassa em <span style="color: red; font-weight: bold;">';
        string += this.desiredAmount - this.storeStockQuantity;
        string += '</span><br> o estoque disponível na sua loja.';
      } else {
        string += 'Produto sem estoque para a loja atual.';
      }

      string += '<br>Deseja solicitar venda de estoque negativo?';

      return string;
    },
  },

  mounted() {
    this.quantity = this.desiredAmount - this.storeStockQuantity;
  },

  methods: {
    addProductToCart() {
      this.$emit('change-quantity', parseInt(this.hasStock ? this.desiredAmount : this.quantity, 10));
      this.addToCart(false, '/personalizar');
      this.close();
      this.requestSent = false;
    },

    async createRequest() {
      try {
        this.requestSent = true;
        await this.requestApproval();
        this.$set(this.productSelected, 'status', this.requestInfo.status);
        this.$set(this.productSelected, 'approvalId', this.requestInfo._id);
        this.$set(this.productSelected, 'checkbox', true);
      } catch (e) {
        console.log(e);
      }
    },

    async requestApproval() {
      try {
        const quantity = parseInt(this.quantity, 10);
        const approvalRequest = {
          type: 'STOCK',
          customerId: this.getCustomer.id,
          storeId: this.getStore.id,
          sellerId: this.$auth.user.sub,
          sellerName: this.getProfile.name,
          product: {
            idERP: this.productSelected.idERP,
            reference: this.productSelected.reference,
            description: this.productSelected.descricaoCurta,
            quantity,
          },
        };
        const res = await client.chain.mutation.createApprovalRequest({
          approvalRequest,
        }).get({ ...everything });
        this.requestInfo = res;
      } catch (e) {
        console.log(e);
      }
    },
  },
};

</script>
 <style scoped lang="scss">

::v-deep input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

::v-deep input[type="number"] {
  -moz-appearance: textfield;
}

%dialog-action-btn {
  font-weight: 600;
  font-size: 12px;
  line-height: 10px;
  text-transform: none;
  height: 32px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
}

$circle-size: 60px;
$color-green: #77c861;

::v-deep .v-label {
  font-size: 15px;
}

.zerostock {
  &__title {
    font-family: 'Nunito Sans', sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    max-width: 21rem;
    margin: 0 auto;
    padding: 0 16px 0 6px;
    text-align: left;
  }
  &__subtitle {
    font-family: 'Nunito Sans', sans-serif;
    font-size: 14px;
    font-weight: 600;
    max-width: 21rem;
    margin: 0 auto;
    text-align: left;
    padding: 10px 6px;
  }
  &__input {
    padding: 0 24px;
  }
  &__msg {
    font-family: 'Nunito Sans', sans-serif;
    font-size: 16px;
    font-weight: 600;
    max-width: 21rem;
    margin: 0 auto;
    text-align: center;
  }
  &__close {
    display: flex;
    justify-content: end;
  }
  &__btn-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &__confirm, &__decline {
    width: 264px;
    color: white;
    text-transform: none;
    border-radius: 8px;
    font-size: 12px;
    margin-bottom: 15px;
  }
  &__animation {
    &__container {
      background-color: white;
      height: 48px;
      width: 275px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
    }
    &__circle, &__circle-border {
      width: $circle-size;
      height: $circle-size;
      border-radius: 50%;
    }
    &__circle {
      z-index: 1;
      position: relative;
      background: white;
      transform: scale(1);
      animation: success-anim 700ms ease;
    }
    &__circle-border {
      z-index: 0;
      position: absolute;
      background: $color-green;
      transform: scale(1.1);
      animation: circle-anim 400ms ease;
    }
    &__success {
      &::before, &::after {
        content: '';
        display: block;
        height: 4px;
        background: $color-green;
        position: absolute;
      }
      &::before {
        width: 17px;
        top: 58%;
        left: 23%;
        transform: rotateZ(50deg);
      }
      &::after {
        width: 30px;
        top: 50%;
        left: 35%;
        transform: rotateZ(-50deg);
      }
    }
  }
}

@keyframes success-anim {
  0% {
    transform: scale(0);
  }
  30% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes circle-anim {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1.1);
  }
}

.product-edit-dialog {
  font-family: 'Nunito Sans';
  &__close {
    display: flex;
    justify-content: end;
    &__btn {
      z-index: 10;
      margin: 10px 0 0;
      height: fit-content;
      width: fit-content;
    }
  }
  &__cancel {
    @extend %dialog-action-btn;
    max-width: 108px;
  }
  &__confirm {
    @extend %dialog-action-btn;
    max-width: 164px;
  }
}

</style>
